"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payhere = exports.AccountCategory = void 0;
var AccountCategory;
(function (AccountCategory) {
    AccountCategory[AccountCategory["LIVE"] = 0] = "LIVE";
    AccountCategory[AccountCategory["SANDBOX"] = 1] = "SANDBOX";
})(AccountCategory || (exports.AccountCategory = AccountCategory = {}));
class Payhere {
    static init(merchantId, accountType, merchantSecret, customerInfo) {
        this._merchantId = merchantId;
        if (accountType === AccountCategory.LIVE) {
            this._baseUrl = 'https://www.payhere.lk';
        }
        else if (accountType === AccountCategory.SANDBOX) {
            this._baseUrl = 'https://sandbox.payhere.lk';
        }
        else
            throw new Error('Account type is required, but has not been provided. Should be either LIVE or SANDBOX');
        if (merchantSecret) {
            const authCode = this.genAuthCode(merchantSecret);
            this._accessToken = this.genAccessToken(authCode);
        }
        if (customerInfo) {
            this._customerInfo = customerInfo;
        }
    }
    static get merchantId() {
        return Payhere._merchantId;
    }
    static get baseUrl() {
        return Payhere._baseUrl;
    }
    static get accessToken() {
        return Payhere._accessToken;
    }
    static get customerInfo() {
        return Payhere._customerInfo;
    }
    static genAuthCode(merchantSecret) {
        return 'auth-code';
    }
    static genAccessToken(authorizationCode) {
        return 'access-token';
    }
}
exports.Payhere = Payhere;
